import { useThemeUI } from 'theme-ui'
export const useTheme = () => useThemeUI().theme
